import React, { useState, useEffect } from "react";
import EmployeeAction from "../EmployeeAction";

const ActionModal = (props) => {
  return <EmployeeAction {...props} />;
};

export default ActionModal;
